export default __webpack_public_path__ + "static/media/ff-force-hover.ecb66757.svg";